module.exports = __webpack_public_path__ + "static/media/userImg.ef67beb1.png";